import {getApps, initializeApp} from 'firebase/app';

if (!process.env.REACT_APP_FIREBASE_CONFIG) {
    throw new Error('Missing FIREBASE_CONFIG env variable');
}

const config = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || '{}');
export const firebaseApp = getApps().length ? getApps()[0] : initializeApp(config);
